import { asCurrency } from "./Utils"

// "$3.00" -> "$3", while "$3.50" keeps its cents
export function formatDepositAmount(amount) {
  return asCurrency(amount).replace(/\.00$/, '')
}

// Total deposit per unit across a unit's returnable containers (crates, jars, etc.)
export function returnableContainersDeposit(returnableContainers, quantityKey = 'quantity') {
  return returnableContainers.reduce((total, returnableContainer) => {
    return total + returnableContainer[quantityKey] * Number(returnableContainer.deposit)
  }, 0)
}

// "Bottle" and "Bottle Deposit" both read as "bottle deposit"
function returnableContainerLabel(returnableContainer) {
  const name = returnableContainer.name.toLowerCase()
  return name.includes('deposit') ? name : `${ name } deposit`
}

// e.g. "12 x $3 bottle deposit, 1 x $8 crate deposit"
export function describeReturnableContainers(returnableContainers, quantityKey = 'quantity') {
  return returnableContainers.map((returnableContainer) => {
    const deposit = formatDepositAmount(returnableContainer.deposit)
    const label = returnableContainerLabel(returnableContainer)
    return `${ returnableContainer[quantityKey] } x ${ deposit } ${ label }`
  }).join(', ')
}
